import React from 'react';
import { useTranslation } from 'react-i18next';
import { InformationCircleIcon } from '@heroicons/react/24/solid';
import { XMarkIcon } from '@heroicons/react/24/outline';

export default function InfoCard({
  textComponent,
  collapsed,
  setCollapsed,
  className,
}) {
  const [t] = useTranslation();
  return (
    <div
      className={`flex flex-row items-start
    overflow-hidden border transition-all duration-300 ease-in-out ${
      collapsed
        ? 'ml-auto h-9 w-9 items-center justify-center rounded-full border-blue-100 bg-blue-50'
        : 'w-full justify-between gap-4 rounded-2xl border-blue-100 bg-blue-50/60 p-4'
    } ${className}`}
    >
      {!collapsed && textComponent}
      <button
        className={`shrink-0 rounded-lg transition duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 ${
          collapsed ? '' : '-m-1 p-1 text-slate-400 hover:bg-blue-100/70 hover:text-slate-700'
        }`}
        aria-label={collapsed ? t('my_questions.info_card.show') : t('my_questions.info_card.hide')}
        onClick={() => setCollapsed((prev) => !prev)}
      >
        {collapsed ? (
          <div className="flex h-6 w-6 cursor-pointer items-center justify-center rounded-full">
            <InformationCircleIcon
              className="h-6 w-6 min-w-fit cursor-pointer text-blue-600"
            />
          </div>
        ) : (
          <XMarkIcon className="h-5 w-5" />
        )}
      </button>
    </div>
  );
}
